( function ( $ ) {
	const indyTeaserSlider = $( '.wp-block-indy-teaser-slider .slider' );

	if ( indyTeaserSlider.length ) {
		indyTeaserSlider.slick( {
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: false,
			dots: true,
			draggable: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			speed: 750,
			easing: 'easeout',
		} );
	}
} )( jQuery );
